import { ROLES } from "utils/helpers/enums/roles.enum";

export class UserDTO{
    active: boolean;
    address: string;
    city: string;
    createdAt: Date;
    currentRole: ROLES;
    defaultRole: ROLES;
    deleted: boolean;
    dob: Date;
    email: string;
    firstName: string;
    gender: string;
    id: number;
    language: string;
    lastName: string;
    phone: string;
    profilePicId: number;
    providerId: string | null;
    state: string;
    stripeCustomerId: string;
    updatedAt: Date;
    username: string;
    verified: boolean;
    zipCode: string;

    constructor(data: Partial<UserDTO> = {}){
        for(let key in data){
            this[key] = data[key];
        }
    }
}